import type { BookingFilters, FilterAggregations } from 'types/filters';
import { dynamicFilter } from 'utils/dynamicFilters';

export const dynamicFilters = (
  filters: BookingFilters,
  aggs: FilterAggregations
): BookingFilters => {
  return {
    ...filters,
    createdByUsers: dynamicFilter('createdByUsers', filters, aggs),
    venues: dynamicFilter('venues', filters, aggs),
    spaces: dynamicFilter('spaces', filters, aggs),
    services: dynamicFilter('services', filters, aggs),
    statuses: dynamicFilter('statuses', filters, aggs),
    paymentStatuses: dynamicFilter('paymentStatuses', filters, aggs),
  };
};
